module.exports = new __parcel__URL__("../treeAnnotation.a013dcdd.png").toString();